class AccordionContent extends HTMLElement {
	constructor() {
		super();
		this.productItems = "[js-product-item]";
		this.addToCartBtns = this.querySelectorAll("[js-hb-atc-btn]");
		this.storeCurrency = this.dataset.storeCurrency;
		this.init();
	}

	init() {
		this.updatePrice();

		this.querySelectorAll(
			"[js-product-item] [js-product-card-inner-wrapper]"
		).forEach((item, index) => {
			item.addEventListener("click", (evt) => {
				const parent = item.closest("[js-product-item]");
				parent.classList.toggle("selected");
				this.updatePrice();
				this.updateButtonInputs(parent);
			});
		});

		this.querySelectorAll("inpiration-variant-selects").forEach(
			(inspirationVariant) => {
				inspirationVariant.addEventListener("change", (event) => {
					this.onVariantChange(event);
				});

				this.checkAvailability(inspirationVariant);
			}
		);
	}

	currentVariant(inspirationVariant) {
		const options = Array.from(
			inspirationVariant.querySelectorAll("select"),
			(select) => select.value
		);
		const variantData = JSON.parse(
			inspirationVariant.querySelector('[type="application/json"]').textContent
		);

		return variantData.find((variant) => {
			return !variant.options
				.map((option, index) => options[index] === option)
				.includes(false);
		});
	}

	onVariantChange(event) {
		const inspirationVariant = event.currentTarget;
		const parent = inspirationVariant.closest("[js-product-item]");
		if (!parent) return;

		// if (this.currentVariant(inspirationVariant)) {
		//   const discountPricePercent = Number(parent.dataset.productDiscountPercent);
		//   console.log({discountPricePercent});
		//   parent.dataset.productPrice = this.currentVariant(inspirationVariant).price;

		//   this.checkAvailability(inspirationVariant)
		//   this.updatePrice();
		//   this.updateButtonInputs(parent, this.currentVariant(inspirationVariant).id);
		// }
		if (this.currentVariant(inspirationVariant)) {
			const discountPricePercent = Number(
				parent.dataset.productDiscountPercent
			);
			const originalPrice = this.currentVariant(inspirationVariant).price;
			if (discountPricePercent) {
				const discountedPrice =
					originalPrice - (originalPrice * discountPricePercent) / 100;
				parent.dataset.productPrice = discountedPrice.toFixed(2);
				parent.querySelector("[js-price-item--compare-price]").innerHTML =
					`${this.storeCurrency}${(originalPrice / 100).toFixed(2)}`;
				parent.querySelector("[js-price-item--sale]").innerHTML =
					`${this.storeCurrency}${(discountedPrice / 100).toFixed(2)}`;
			} else {
				parent.dataset.productPrice = originalPrice;
				parent.querySelector("[js-price-item--sale]").innerHTML =
					`${this.storeCurrency}${(originalPrice / 100).toFixed(2)}`;
			}

			this.checkAvailability(inspirationVariant);
			this.updatePrice();
			this.updateButtonInputs(
				parent,
				this.currentVariant(inspirationVariant).id
			);
		}

		const immediateParent = event.target.closest(
			".inspiration-option__wrapper"
		);
		if (immediateParent) {
			const selectedValueEl = immediateParent.querySelector(
				"[hb-data-selected-value]"
			);
			if (selectedValueEl) {
				selectedValueEl.textContent =
					event.target.options[event.target.selectedIndex].text;
			}
		}
	}

	checkAvailability(inspirationVariant) {
		const parent = inspirationVariant.closest("[js-product-item]");
		if (!parent) return;
		if (this.currentVariant(inspirationVariant).available) {
			parent.classList.remove("sold-out");
		} else {
			parent.classList.add("sold-out");
			if (parent.classList.contains("selected")) {
				parent.querySelector("[js-product-card-inner-wrapper]").click();
			}
		}
	}

	updatePrice() {
		const activeProducts = this.querySelectorAll(
			`${this.productItems}.selected`
		);
		const activeProductsCount = activeProducts.length;
		const cartItems = [];

		activeProducts.forEach((product) => {
			const productPrice = Number(product.getAttribute("data-product-price"));
			if (productPrice) {
				cartItems.push(productPrice);
			}
		});

		const totalPrice = cartItems.reduce((sum, price) => sum + price, 0);
		const addToCartButton = this.querySelector("[js-add-to-cart-btn]");

		if (addToCartButton) {
			if (activeProductsCount > 0) {
				addToCartButton.innerHTML = `
          <button type="submit" class="button">
            <span>Add <span js-total-items>${activeProductsCount}</span> ${activeProductsCount > 1 ? "items" : "item"} To Cart</span><span> — </span><span js-total-price>${this.storeCurrency}${(totalPrice / 100).toFixed(2)}</span>
          </button>
        `;
				addToCartButton.classList.remove("disabled");
			} else {
				addToCartButton.innerHTML = `
          <button type="submit" class="button">
            <span>Add <span js-total-items>${activeProductsCount}</span> Item To Cart</span><span> — </span><span js-total-price>${this.storeCurrency}0.00</span>
          </button>
        `;
				addToCartButton.classList.add("disabled");
			}
		}
	}

	updateButtonInputs(parent, id = null) {
		const index = parent.dataset.index;
		const inputField = this.querySelector(`input[name="items[${index}][id]"]`);

		if (inputField) {
			if (!parent.classList.contains("selected")) {
				inputField.setAttribute("disabled", "disabled");
			} else {
				inputField.removeAttribute("disabled");
			}
			if (id !== null) {
				inputField.value = id;
			}
		}
	}
}

customElements.define("accordion-content", AccordionContent);
